import React from "react";

const Java_Data_Types = () => {
  return (
    <div>
      <h1>Java Data Types</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Data Types in Java.</p>
    </div>
  );
};

export default Java_Data_Types;
